import React from 'react';
import { Layout } from 'antd';
import './footer.scoped.scss';

export function Footer() {
  const { Footer } = Layout;

  const maskCustomerName =
    (process.env.REACT_APP_MDM_ENV !== 'test' || window.location.hostname.includes('mdm.setwiser.com')) &&
    process.env.REACT_APP_MDM_ENV !== 'prod';

  return (
    <Footer style={{ textAlign: 'center', backgroundColor: '#000', padding: '1rem 0', color: '#eee' }}>
      <div style={{ marginBottom: '1rem' }}>
        {!maskCustomerName && 'Roketsan '}Ana Veri Yönetimi {process.env.REACT_APP_MDM_VERSION}
        {process.env.REACT_APP_MDM_IS_TEST_VERSION === 'true' ? ' - Test' : ''}{' '}
        {process.env.REACT_APP_MDM_BUILD_DATE
          ? `(${process.env.REACT_APP_MDM_BUILD_DATE} -
        ${process.env.REACT_APP_MDM_COMMIT_HASH})`
          : ''}
        {' '}© 2025
      </div>
      <hr />
      {!maskCustomerName && <img src="/rs_logo_name.png" alt="Roketsan" style={{ width: '15rem' }} />}
    </Footer>
  );
}
